import styled from 'styled-components';
import { colors, mixins } from '../css';
import SVGIcon from '../SVGIcon';

export const StyledCardContainer = styled.div`
  position: relative;
`;

export const StyledIconSpacing = styled.div`
  margin: 0 ${mixins.pxToRem(4)};
  width: ${mixins.pxToRem(22)};
  height: 22px;
  display: inline-block;
`;

export const StyledFavouriteButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  position: absolute;
  z-index: 1;
  top: ${mixins.pxToRem(20)};
  right: ${mixins.pxToRem(20)};
  cursor: pointer;
`;

export const StyledImageDefault = styled.div`
  background-color: ${colors.colorGrey04};
  display: block;
  width: 100%;
  height: auto;
  padding-top: calc(4 / 6 * 100%);
  overflow: hidden;
  position: relative;
`;
export const StyledSVGContainer = styled.div`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
export const StyledSVGPlacement = styled(SVGIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`;
